"use client";
import LoginPage from "./LoginPage";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import { Helmet } from "react-helmet"

import seoData from '@/data/seo.json'
export default function LogIn() {
  const seo = seoData['login']
  return (
   <div>
           <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
      </Helmet>
        <Header />
        <div  className="min-h-screen max-w-[748px] mx-auto flex flex-col items-center pb-36 px-4 mt-8">
          <LoginPage />
        </div>
       
        <Footer />
 
    </div>
  );
}

